import React, { useState, useRef, useEffect } from "react";
import "../LedgerList/LedgerList.css";
import axios from "axios";
import close from "../../../assets/images/close.png";
import sslogo from "../../../assets/images/SS.png";
import { ClipLoader } from "react-spinners";
// import { useDbContext } from "../../../context/DbContext";
import ComboBox from "../../ComboBox";
import show from "../../../assets/images/check-mark .png";
import Toexcel from "../../../assets/images/ToExcel.png";
import * as XLSX from "xlsx";
import io from "socket.io-client";
import Input from "postcss/lib/input";

function LedgerList({ onClose }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  // const { dbCode } = useDbContext();
  const parentRef = useRef(null);
  const lednameRef = useRef(null);
  const phoneNoRef = useRef(null);
  const agentRef = useRef(null);
  const routeRef = useRef(null);
  const deliverydateRef = useRef(null);

  const [tableData, setTableData] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [employeeNames, setEmployeeNames] = useState([]);

  const [LedgerListData, setLedgerListData] = useState({
    reportType:["Ledger_List","Ledger List"],
    parent: "",
    ledName: "",
    phoneNo: "",
    agent: "",
  
  });
  const getTableHeaders = () => {
    if (tableData.length === 0) return [];
    return Object.keys(tableData[0]);
  };
  const fetchData = async () => {
    
    try {
      const response = await axios.get(`${apiBaseUrl}/LedList`, {
        params: LedgerListData,
      });
      setTableData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const fetchData = async () => {
  //   setIsLoading(true); // Show loader when the search starts
  //   try {
  //     const url = `${apiBaseUrl}/main/LedList/${dbCode}}`;

  //     //console.log("Requesting URL:", url);
  //     const response = await axios.get(url);
  //     setTableData(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false); // Hide loader after data is fetched or error occurs
  //   }
  // };

  const spinnerProps = {
    color: "#026CC3",
    size: 30,
    speedMultiplier: 0.8,
    css: {
      opacity: "0.8",
    },
  };

  const handleCheckboxChange = (field) => {
    setSelectedField(field);
  };

  const handleRowClick = (index) => {
    setSelectedRowIndex(index);
  };
  //console.log("LedgerListData=", LedgerListData);
  const [under, setUnder] = useState([]);

  const fetchparent = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/spledgerheads`
      );
      const parDetails = response.data;
      // //console.log("parDetails=",parDetails);
      
      const under = parDetails.map((item) => [item.lh_id, item.lh_name]);
      setUnder(under);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };
  const [Lednames, setLednames] = useState([]);
  const fetchLednamesNames = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/spledgernames`);
      const ledDetails = response.data;
      const lednames = ledDetails.map((item) => [item.Ledcode, item.LedName]);
      setLednames(lednames);
    } catch (error) {
      console.error("Error fetching names Values:", error.message);
    }
  };
  
  useEffect(() => {
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("dataUpdated", () => {
      //   //////console.log('Data updated, fetching new data...');
      fetchLednamesNames();
    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
      //   //////console.log("socketdisconneccted");
    };
  }, [apiBaseUrl]);
  const exportToExcel = () => {
    if (tableData.length === 0) {
      alert("No data available to export!");
      return;
    }

    // Prepare the data for Excel
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "LedgerList");

    // Download the Excel file
    XLSX.writeFile(workbook, "LedgerList.xlsx");
  };



  const fetchEmployeeNames = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/SchReg_empname`);

      const empNames = response.data.map((item) => [item.Auto, item.name]);

      setEmployeeNames(empNames);
    } catch (error) {
      console.error("Error fetching employee names:", error.message);
    }
  };
  return (
    <div className="LedgerListRoot">
      <div className="LedgerListHead">
        <span
          style={{ width: "20%", marginLeft: "1%" }}
          className="flex gap-2 text-xs items-center"
        >
          <div className="h-6 w-5">
            <img src={sslogo} alt="Ss" className="h-full w-full " />
          </div>
          Ledger List
        </span>
        <button
          className="controllsbuttons xbutton"
          style={{ position: "absolute", right: "20px" }}
          onClick={onClose}
        >
          <img src={close} alt="X" />
        </button>
      </div>
      <div className="LedgerListBody">
        <div className="LedgerListBodyHead">
          <div className="h-full w-1/3 flex items-center justify-center flex-col gap-2 al">
          <div className="w-full h-[25%] flex gap-1 items-center">
              <label htmlFor="" className="ledgerlistLabels">
                Report Type
              </label>
              <ComboBox
                comboRef={phoneNoRef}
                options={[
                  ["Ledger_List", "Ledger List"],
                  ["Agent_List", "Agent List"]
                  
                ]}
                findedValue={
                  Array.isArray(LedgerListData.reportType)
                    ? LedgerListData.reportType[1]
                    : LedgerListData.reportType
                }
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    reportType: e,
                  })
                }
                className="ledgerListCombo w-2/3 h-[80%]"
              />
            </div>
            <div className="w-full h-[25%] flex gap-1 items-center">
              <label htmlFor="" className="ledgerlistLabels">
                {" "}
                Parent
              </label>
              <ComboBox
                comboRef={parentRef}
                findedValue={
                  Array.isArray(LedgerListData.parent)
                    ? LedgerListData.parent[1]
                    : LedgerListData.parent
                }
                options={under}
                onFocus={(e)=>fetchparent(e)}
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    parent: e,
                  })
                }
                className="ledgerListCombo w-2/3 h-[80%]"
              />
            </div>
            <div className="w-full h-[25%] flex gap-1 items-center">
              <label htmlFor="" className="ledgerlistLabels">
              
                Led Name
              </label>
              <ComboBox
                comboRef={lednameRef}
                options={Lednames}
                findedValue={
                  Array.isArray(LedgerListData.ledName)
                    ? LedgerListData.ledName[1]
                    : LedgerListData.ledName
                }
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    ledName: e,
                  })
                }
                onFocus={fetchLednamesNames}
                className="ledgerListCombo w-2/3 h-[80%]"
              />
            </div>
           
          </div>
          <div className="h-full w-1/3 flex items-center justify-center flex-col gap-2">
         
            <div className="w-full h-[25%] flex gap-1 items-center">
              <label htmlFor="" className="ledgerlistLabels pl-5">
                Agent
              </label>
              <ComboBox
                comboRef={routeRef}
                findedValue={
                  Array.isArray(LedgerListData.agent)
                    ? LedgerListData.agent[1]
                    : LedgerListData.agent
                }
                onFocus={fetchEmployeeNames}
                options={employeeNames}
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    agent: e,
                  })
                }
                className="ledgerListCombo w-2/3 h-[80%]"
              />
            </div>
            <div className="w-full h-[25%] flex gap-1 items-center">
              <label htmlFor="phone" className="ledgerlistLabels pl-5">
                Phone Number
              </label>
              <ComboBox
                comboRef={lednameRef}
                options={[]}
                id='phone'
                findedValue={
                  Array.isArray(LedgerListData.phoneNo)
                    ? LedgerListData.phoneNo[1]
                    : LedgerListData.phoneNo
                }
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    phoneNo: e,
                  })
                }
                className="ledgerListCombo w-2/3 h-[80%]"
              />
            </div>
            <div className="w-full h-[25%] flex gap-1 items-center">
              {/* <label htmlFor="" className="ledgerlistLabels pl-5">
              
                Led Name
              </label>
              <ComboBox
                comboRef={lednameRef}
                options={Lednames}
                findedValue={
                  Array.isArray(LedgerListData.ledName)
                    ? LedgerListData.ledName[1]
                    : LedgerListData.ledName
                }
                onInputChange={(e) =>
                  setLedgerListData({
                    ...LedgerListData,
                    ledName: e,
                  })
                }
                onFocus={fetchLednamesNames}
                className="ledgerListCombo w-2/3 h-[80%]"
              /> */}
            </div>
          </div>
          <div className="h-full w-1/3 flex flex-col gap-3 ">
            <div className="w-full h-[52%]  mt-1.5 flex gap-2 justify-center">
              <button
                className="w-1/3 h-full  flex flex-col gap-1 items-center justify-center"
                onClick={fetchData}
              >
                <img className="h-2/3 w-auto" src={show} alt="Show" />
                Show
              </button>

              <button className="w-1/3 h-full flex flex-col gap-1 items-center justify-center" onClick={exportToExcel}>
                <img className="h-2/3 w-auto" src={Toexcel} alt="Toexcel" />
                To Excel
              </button>
            </div>
          </div>
        </div>

        <div className="LedgerListTable">
          {isLoading ? (
            <div className="loader-container">
              <ClipLoader {...spinnerProps} />
            </div>
          ) : tableData.length > 0 ? (
            <table>
              <thead className="LedgerListDataTableHead">
                <tr>
                  {getTableHeaders().map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className={index === selectedRowIndex ? "selected-row" : ""}
                    onClick={() => handleRowClick(index)}
                  >
                    {getTableHeaders().map((key) => (
                      <td className="LedgerListDataTableDataBox" key={key}>
                        {row[key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default LedgerList;
